import React from "react";
import { LlmUsageSummary } from "../../../types/llm-usage.types";
import {
  formatCurrency,
  formatTokens,
  formatNumber,
} from "../../../utils/formatters";

interface SummaryCardsProps {
  summary: LlmUsageSummary;
}

interface CardProps {
  label: string;
  value: string;
  testId: string;
  ariaLabel: string;
}

const Card: React.FC<CardProps> = ({ label, value, testId, ariaLabel }) => (
  <div
    className="bg-white rounded-lg border border-neutral-200 p-4 shadow-sm"
    data-testid={testId}
    aria-label={ariaLabel}
  >
    <div className="text-xs font-medium text-neutral-500 uppercase mb-1">
      {label}
    </div>
    <div
      className="text-2xl font-semibold text-neutral-900"
      data-testid={`${testId}-value`}
    >
      {value}
    </div>
  </div>
);

export const SummaryCards: React.FC<SummaryCardsProps> = ({ summary }) => {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
      role="region"
      aria-label="Podsumowanie użycia LLM"
    >
      <Card
        label="Całkowity koszt"
        value={formatCurrency(summary.totalCostUsd)}
        testId="metric-total-cost"
        ariaLabel={`Całkowity koszt: ${formatCurrency(summary.totalCostUsd)}`}
      />
      <Card
        label="Tokeny wejściowe"
        value={formatTokens(summary.totalInputTokens)}
        testId="metric-input-tokens"
        ariaLabel={`Tokeny wejściowe: ${formatNumber(summary.totalInputTokens)}`}
      />
      <Card
        label="Tokeny wyjściowe"
        value={formatTokens(summary.totalOutputTokens)}
        testId="metric-output-tokens"
        ariaLabel={`Tokeny wyjściowe: ${formatNumber(summary.totalOutputTokens)}`}
      />
      <Card
        label="Liczba rekordów"
        value={formatNumber(summary.recordCount)}
        testId="metric-records"
        ariaLabel={`Liczba rekordów: ${formatNumber(summary.recordCount)}`}
      />
    </div>
  );
};

export default SummaryCards;
